var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Divider, Grid, Typography, InputAdornment, IconButton, } from '@mui/material';
import { CloudDownload, Close as CloseIcon } from '@mui/icons-material';
import { useFormik } from 'formik';
import { useRequest } from '../hooks/requestHook';
import { useNotify } from '../hooks/notificationHook';
import { roaster as api } from '../api';
import { JP_PREFECTURES } from '../constants/roasterValues';
import PageSubmitButton from './molecules/PageSubmitButton';
import { FormikSelectField } from './atoms/SelectField';
import { FormikTextField } from './atoms/TextField';
import { FormikRadioGroup } from './atoms/RadioGroup';
import { FormikCheckboxGroup } from './atoms/CheckboxGroup';
import FormikSelectCountryCallingCodeField from './atoms/FormikSelectCountryCallingCodeField';
import { FormikFileField } from './atoms/FileField';
import DownloadLink from './organisms/DownloadLink';
import { RoasterFieldFormats, TaiwanRoasterFieldFormats, JapanRoasterFieldFormats, JapanRoasterAddressHalfWidthMaxLength, JapanRoasterBuildingHalfWidthMaxLength, japanRoasterAddressTest, japanRoasterBuildingTest, } from '../constants/fieldFormats';
import Dialog from './atoms/Dialog';
import { TradeCounties } from '../constants/roasterValues';
import { camelize, capitalize } from '../utils/camelize';
import { useCommunityManagers } from '../hooks/useCommunityManagers';
import { useRoasterCountries } from '../hooks/useRoasterCountries';
import TradeCountryEditForm from './TradeCountryEditForm';
var DownloadLinkWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-flex;\n  margin: 10px 20px;\n  text-align: center;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"], ["\n  display: inline-flex;\n  margin: 10px 20px;\n  text-align: center;\n\n  a {\n    color: inherit;\n    text-decoration: none;\n  }\n"])));
var toBooleanString = function (value) {
    if (value === true)
        return '1';
    if (value === false)
        return '0';
    return;
};
var REQUIRED_FIELDS = [
    'company',
    'firstname',
    'lastname',
    'postal_code',
    'prefecture',
    'city',
    'address',
    'phone',
    'customer_type',
    'store_type',
    'roaster_maker',
    'roasted_per_month',
    'roaster_max_capacity',
    'country_id',
    'country_calling_code',
    'is_q_grader',
];
var toFormValues = function (roaster) {
    var _a, _b, _c, _d;
    return ({
        company: roaster.company,
        firstname: roaster.firstname,
        lastname: roaster.lastname,
        name_kana: roaster.nameKana,
        store_name: roaster.storeName,
        postal_code: roaster.postalCode,
        prefecture: roaster.prefecture,
        city: roaster.city,
        address: roaster.address,
        building: roaster.building,
        phone: roaster.phone,
        country_calling_code: roaster === null || roaster === void 0 ? void 0 : roaster.countryCallingCode,
        homepage_url: roaster.homepageUrl,
        roaster_maker: roaster.roasterMaker,
        roaster_max_capacity: roaster.roasterMaxCapacity,
        roasted_per_month: roaster.roastedPerMonth,
        customer_type: roaster.customerType || 'corporation',
        store_count: roaster.storeCount === null ? undefined : roaster === null || roaster === void 0 ? void 0 : roaster.storeCount,
        have_ec_shop: toBooleanString(roaster.haveEcShop),
        business_type: roaster.businessType,
        store_type: roaster.storeType,
        trade_countries: roaster.tradeCountries,
        trading_countries: (_a = roaster.tradeCountries) === null || _a === void 0 ? void 0 : _a.filter(function (country) { return country.tradeType === 'trading'; }).map(function (country) { return country.country; }),
        want_trade_countries: (_b = roaster.tradeCountries) === null || _b === void 0 ? void 0 : _b.filter(function (country) { return country.tradeType === 'want'; }).map(function (country) { return country.country; }),
        country_id: ((_c = roaster.country) === null || _c === void 0 ? void 0 : _c.id) || '',
        eori_number: roaster.eoriNumber,
        is_q_grader: roaster.isQGrader ? '1' : '0',
        vat_number: roaster.vatNumber || '',
        business_number_jp: roaster.businessNumberJp || '',
        business_number_kr: roaster.businessNumberKr || '',
        business_number_tw: roaster.businessNumberTw || '',
        business_number_kr_document: undefined,
        community_engagement: roaster.communityEngagement,
        community_manager_id: ((_d = roaster.communityManager) === null || _d === void 0 ? void 0 : _d.id) || '',
    });
};
var RoasterEditForm = function (_a) {
    var _b;
    var roaster = _a.roaster, onUpdate = _a.onUpdate, admin = _a.admin;
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    var notify = useNotify();
    var updateRoaster = useRequest(api.update);
    var communityManagerListItems = useCommunityManagers(admin || false).communityManagerListItems;
    var _d = useRoasterCountries(), roasterCountries = _d.roasterCountries, roasterCountryListItems = _d.roasterCountryListItems;
    var _e = React.useState(false), loading = _e[0], setLoading = _e[1];
    var initialValues = React.useMemo(function () { return toFormValues(roaster); }, [roaster]);
    var _f = React.useState(false), editTradeCountryOpen = _f[0], setEditTradeCountryOpen = _f[1];
    var _g = React.useState(), editTradeCountry = _g[0], setEditTradeCountry = _g[1];
    var findTradeCountry = function (values, tradeType, country) {
        var _a;
        return (_a = values.trade_countries) === null || _a === void 0 ? void 0 : _a.find(function (formikTradeCountry) {
            return (formikTradeCountry.tradeType === tradeType &&
                formikTradeCountry.country === country);
        });
    };
    var onSubmit = React.useCallback(function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var formData, trading_countries, want_trade_countries, response;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    formData = new FormData();
                    Object.entries(values).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        if (value === null || value === undefined)
                            return;
                        if ([
                            'trading_countries',
                            'want_trade_countries',
                            'trade_countries',
                            'business_number_kr_document',
                        ].includes(key))
                            return;
                        formData.append("roaster[".concat(key, "]"), value);
                    });
                    if (values.business_number_kr_document) {
                        formData.append('roaster[business_number_kr_document]', values.business_number_kr_document);
                    }
                    trading_countries = ((_a = values.trading_countries) === null || _a === void 0 ? void 0 : _a.map(function (country) {
                        return (findTradeCountry(values, 'trading', country) || {
                            tradeType: 'trading',
                            country: country,
                        });
                    })) || [];
                    want_trade_countries = ((_b = values.want_trade_countries) === null || _b === void 0 ? void 0 : _b.map(function (country) {
                        return (findTradeCountry(values, 'want', country) || {
                            tradeType: 'want',
                            country: country,
                        });
                    })) || [];
                    trading_countries
                        .concat(want_trade_countries)
                        .forEach(function (tradeCountry) {
                        formData.append('roaster[trade_countries][]', JSON.stringify(tradeCountry));
                    });
                    return [4 /*yield*/, updateRoaster({
                            id: roaster.id,
                            roaster: formData,
                        })];
                case 1:
                    response = _c.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    onUpdate(response);
                    notify('success', [t('messages.updateSuccess')]);
                    return [2 /*return*/];
            }
        });
    }); }, [t, updateRoaster, notify, onUpdate, roaster]);
    var validate = React.useCallback(function (values) {
        var errors = {};
        var roasterCountry = roaster.country ||
            roasterCountries.find(function (country) { return country.id === values['country_id']; });
        var requiredFields = (roasterCountry === null || roasterCountry === void 0 ? void 0 : roasterCountry.code) === 'KR' && values.customer_type === 'corporation'
            ? REQUIRED_FIELDS.concat([
                'business_number_kr',
                'business_number_kr_document',
            ])
            : REQUIRED_FIELDS;
        requiredFields.forEach(function (field) {
            if (field === 'business_number_kr_document' &&
                roaster.businessNumberKrDocument)
                return;
            if (!values[field] || values[field] === '') {
                errors[field] = t('errors.isRequired', {
                    field: t("params.roaster.".concat(camelize(field))),
                });
            }
        });
        var roasterFieldFormats = RoasterFieldFormats;
        if ((roasterCountry === null || roasterCountry === void 0 ? void 0 : roasterCountry.code) === 'TW')
            roasterFieldFormats = TaiwanRoasterFieldFormats;
        if ((roasterCountry === null || roasterCountry === void 0 ? void 0 : roasterCountry.code) === 'JP' && roaster.isUsMilitaryBase === false)
            roasterFieldFormats = JapanRoasterFieldFormats;
        roasterFieldFormats.forEach(function (_a) {
            var field = _a.field, regexp = _a.regexp, error = _a.error;
            var fieldAsKey = field;
            var value = values[fieldAsKey];
            if (typeof value === 'number')
                value = "".concat(value);
            if (typeof value === 'string' && !regexp.test(value)) {
                errors[fieldAsKey] = t("errors.".concat(error), {
                    field: t("params.roaster.".concat(camelize(field))),
                });
            }
        });
        if ((roasterCountry === null || roasterCountry === void 0 ? void 0 : roasterCountry.code) === 'JP' && roaster.isUsMilitaryBase === false) {
            if (values.address && !japanRoasterAddressTest(values.address)) {
                errors.address = t('errors.invalidAddress', {
                    field: t('params.roaster.address'),
                    fullWidthMaxLength: JapanRoasterAddressHalfWidthMaxLength / 2,
                    halfWidthMaxLength: JapanRoasterAddressHalfWidthMaxLength,
                });
            }
            if (values.building && !japanRoasterBuildingTest(values.building)) {
                errors.building = t('errors.invalidAddress', {
                    field: t('params.roaster.building'),
                    fullWidthMaxLength: JapanRoasterBuildingHalfWidthMaxLength / 2,
                    halfWidthMaxLength: JapanRoasterBuildingHalfWidthMaxLength,
                });
            }
        }
        if (values.customer_type === 'corporation' && !values.company) {
            errors.company = t('errors.isRequired', {
                field: t("params.roaster.company"),
            });
        }
        else {
            delete errors.company;
        }
        if (values.customer_type !== 'corporation') {
            delete errors.business_number_tw;
        }
        return errors;
    }, [t, roaster, roasterCountries]);
    var formik = useFormik({
        initialValues: initialValues,
        onSubmit: onSubmit,
        validate: validate,
        validateOnChange: true,
        validateOnMount: true,
        enableReinitialize: true,
    });
    var getItems = React.useCallback(function (key) {
        var options = t(key, { returnObjects: true });
        return Object.entries(options).map(function (_a) {
            var value = _a[0], text = _a[1];
            return ({ value: value, text: text });
        });
    }, [t]);
    var customerTypeItems = React.useMemo(function () { return getItems('params.roaster.customerTypes'); }, [getItems]);
    var roasterMakerItems = React.useMemo(function () { return getItems('params.roaster.roasterMakerOptions'); }, [getItems]);
    var communityEngagementItems = React.useMemo(function () { return getItems('params.roaster.communityEngagements'); }, [getItems]);
    var isExistsItems = React.useMemo(function () { return getItems('options.isExists'); }, [getItems]);
    var handleOpenTradeCountryEditForm = React.useCallback(function (tradeType, country) {
        var formikTradeCountry = findTradeCountry(formik.values, tradeType, country);
        setEditTradeCountry(formikTradeCountry || { tradeType: tradeType, country: country });
        setEditTradeCountryOpen(true);
    }, [formik, setEditTradeCountry, setEditTradeCountryOpen]);
    var handleCloseTradeCountryEditForm = React.useCallback(function () {
        setEditTradeCountry(undefined);
        setEditTradeCountryOpen(false);
    }, [setEditTradeCountry, setEditTradeCountryOpen]);
    var handleChangeTradingCountries = React.useCallback(function (values, checkedValue) {
        formik.setFieldValue('trading_countries', values);
        if (checkedValue) {
            handleOpenTradeCountryEditForm('trading', checkedValue);
        }
    }, [formik, handleOpenTradeCountryEditForm]);
    var handleChangeWantTradeCountries = React.useCallback(function (values, checkedValue) {
        formik.setFieldValue('want_trade_countries', values);
        if (checkedValue) {
            handleOpenTradeCountryEditForm('want', checkedValue);
        }
    }, [formik, handleOpenTradeCountryEditForm]);
    var handleConfirmTradeCountryEditForm = React.useCallback(function (tradeCountry) {
        var formikTradeCountry = findTradeCountry(formik.values, tradeCountry.tradeType, tradeCountry.country);
        var trade_countries = formik.values.trade_countries || [];
        if (formikTradeCountry) {
            trade_countries = trade_countries.map(function (formikTradeCountry) {
                if (formikTradeCountry.tradeType === tradeCountry.tradeType &&
                    formikTradeCountry.country === tradeCountry.country) {
                    return tradeCountry;
                }
                else {
                    return formikTradeCountry;
                }
            });
        }
        else {
            trade_countries.push(tradeCountry);
        }
        formik.setValues(__assign(__assign({}, formik.values), { trade_countries: trade_countries }));
        handleCloseTradeCountryEditForm();
    }, [formik, editTradeCountry, handleCloseTradeCountryEditForm]);
    var tradeCountriesItems = React.useCallback(function (tradeType, countries) {
        return __spreadArray([], TradeCounties, true).sort(function (a, b) { return t("countries.".concat(a)).localeCompare(t("countries.".concat(b))); })
            .map(function (country) { return ({
            label: (countries === null || countries === void 0 ? void 0 : countries.includes(country)) ? (React.createElement(Link, { to: '#', onClick: function (event) {
                    event.preventDefault();
                    handleOpenTradeCountryEditForm(tradeType, country);
                } }, t("countries.".concat(country)))) : (t("countries.".concat(country))),
            value: country,
        }); });
    }, [t, formik]);
    var storeTypeItems = React.useMemo(function () {
        var items = getItems('params.roaster.storeTypes');
        if (formik.values.customer_type === 'corporation') {
            return items.filter(function (_a) {
                var value = _a.value;
                return value !== 'home';
            });
        }
        return items;
    }, [getItems, formik.values.customer_type]);
    var isQGraderItems = React.useMemo(function () { return getItems('options.isQGrader'); }, [getItems]);
    React.useEffect(function () {
        if (formik.values.customer_type === 'corporation' &&
            formik.values.store_type === 'home') {
            formik.handleChange({ target: { name: 'store_type', value: '' } });
        }
    }, [formik]);
    var currentCountry = React.useMemo(function () {
        return roasterCountries.find(function (country) { return country.id === formik.values.country_id; });
    }, [roasterCountries, formik]);
    return (React.createElement(React.Fragment, null,
        editTradeCountry && (React.createElement(Dialog, { open: editTradeCountryOpen, title: React.createElement(React.Fragment, null,
                t("countries.".concat(editTradeCountry.country)),
                React.createElement(IconButton, { "aria-label": "close", onClick: handleCloseTradeCountryEditForm, sx: { position: 'absolute', right: 8, top: 8 } },
                    React.createElement(CloseIcon, null))), onClose: handleCloseTradeCountryEditForm },
            React.createElement(TradeCountryEditForm, { tradeCountry: editTradeCountry, onConfirm: handleConfirmTradeCountryEditForm }))),
        React.createElement("form", { onSubmit: formik.handleSubmit },
            React.createElement(Grid, { container: true, spacing: 4, style: { marginTop: 5 } },
                admin && (React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikSelectField, { label: t('params.roaster.communityManager'), name: "community_manager_id", items: communityManagerListItems, fullWidth: true, includeBlank: true, formik: formik }))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikRadioGroup, { row: true, label: t('params.roaster.customerType'), name: "customer_type", items: customerTypeItems, formik: formik })),
                formik.values.customer_type === 'corporation' && (React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.company'), name: "company", fullWidth: true, required: true, formik: formik }))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikRadioGroup, { row: true, label: t('params.roaster.storeType'), name: "store_type", items: storeTypeItems, formik: formik })),
                formik.values.store_type !== 'home' && (React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.storeName'), name: "store_name", fullWidth: true, formik: formik }))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.lastname'), name: "lastname", fullWidth: true, required: true, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.firstname'), name: "firstname", fullWidth: true, required: true, formik: formik })),
                i18n.language === 'ja' && (React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.nameKana'), name: "name_kana", fullWidth: true, formik: formik }))),
                React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3 },
                    React.createElement(FormikSelectCountryCallingCodeField, { name: "country_calling_code", label: t('params.roaster.countryCallingCode'), required: true, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 9 },
                    React.createElement(FormikTextField, { label: t('params.roaster.phone'), name: "phone", fullWidth: true, required: true, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3 },
                    React.createElement(FormikTextField, { label: t('params.roaster.postalCode'), name: "postal_code", inputProps: { maxLength: 9 }, fullWidth: true, required: true, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3 },
                    React.createElement(FormikSelectField, { label: t('params.roaster.country'), name: "country_id", items: roasterCountryListItems, fullWidth: true, required: true, disabled: Boolean(initialValues.country_id), formik: formik }),
                    React.createElement(Typography, { variant: "caption" }, t('pages.editProfile.cannotChangeCountry'))),
                currentCountry && currentCountry.eoriNumberEnabled && (React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3 },
                    React.createElement(FormikTextField, { label: t('params.eoriNumber'), name: "eori_number", fullWidth: true, formik: formik }))),
                React.createElement(Grid, { item: true, xs: 12, sm: 6, md: 3 }, (currentCountry === null || currentCountry === void 0 ? void 0 : currentCountry.code) === 'JP' &&
                    roaster.isUsMilitaryBase === false ? (React.createElement(FormikSelectField, { label: t('params.roaster.prefecture'), name: "prefecture", items: JP_PREFECTURES.map(function (prefecture) {
                        return { text: prefecture, value: prefecture };
                    }), fullWidth: true, required: true, formik: formik })) : (React.createElement(FormikTextField, { label: t('params.roaster.prefecture'), name: "prefecture", fullWidth: true, required: true, formik: formik }))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.city'), name: "city", fullWidth: true, required: true, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.address'), name: "address", fullWidth: true, required: true, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.building'), name: "building", fullWidth: true, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.homepageUrl'), name: "homepage_url", fullWidth: true, formik: formik })),
                currentCountry && currentCountry.isEurope && (React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(FormikTextField, { label: t('params.roaster.vatNumber'), name: "vat_number", fullWidth: true, formik: formik }))),
                ['JP', 'KR', 'TW'].map(function (code) { return (React.createElement(React.Fragment, { key: code }, currentCountry && currentCountry.code === code && (React.createElement(Grid, { item: true, xs: 12, sm: 6 },
                    React.createElement(FormikTextField, { label: t("params.roaster.businessNumber".concat(capitalize(code.toLowerCase()))), name: "business_number_".concat(code.toLowerCase()), fullWidth: true, formik: formik }))))); }),
                currentCountry && currentCountry.code === 'KR' && (React.createElement(Grid, { item: true, xs: 12 },
                    !formik.values.business_number_kr_document &&
                        roaster.businessNumberKrDocument && (React.createElement(DownloadLinkWrapper, null,
                        React.createElement(DownloadLink, { url: roaster.businessNumberKrDocument.path, filename: roaster.businessNumberKrDocument.filename },
                            React.createElement(CloudDownload, null),
                            React.createElement("div", null, roaster.businessNumberKrDocument.filename)))),
                    formik.values.business_number_kr_document && (React.createElement(DownloadLinkWrapper, null,
                        React.createElement("div", null, (_b = formik.values.business_number_kr_document) === null || _b === void 0 ? void 0 : _b.name))),
                    React.createElement(FormikFileField, { name: "business_number_kr_document", label: t('labels.uploadBusinessNumberKrdocument'), formik: formik }))),
                admin && (React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikSelectField, { label: t('params.roaster.communityEngagement'), name: "community_engagement", fullWidth: true, required: true, items: communityEngagementItems, formik: formik }))),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(Typography, { variant: "h6" }, t('pages.editProfile.questionnairesForRoaster')),
                    React.createElement(Typography, { variant: "subtitle1" }, t('pages.editProfile.questionnairesForRoasterMemo'))),
                React.createElement(Divider, null),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikSelectField, { label: t('params.roaster.roasterMaker'), name: "roaster_maker", fullWidth: true, required: true, items: roasterMakerItems, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.roasterMaxCapacity'), name: "roaster_max_capacity", InputProps: {
                            endAdornment: (React.createElement(InputAdornment, { position: "end" }, "Kg")),
                        }, required: true, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.roastedPerMonth'), name: "roasted_per_month", InputProps: {
                            endAdornment: (React.createElement(InputAdornment, { position: "end" }, "Kg")),
                        }, required: true, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikTextField, { label: t('params.roaster.storeCount'), name: "store_count", formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikRadioGroup, { row: true, label: t('params.roaster.haveEcShop'), name: "have_ec_shop", items: isExistsItems, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikRadioGroup, { row: true, label: t('params.roaster.businessType'), name: "business_type", items: getItems('params.roaster.businessTypes'), formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikRadioGroup, { row: true, label: t('params.roaster.isQGrader'), name: "is_q_grader", items: isQGraderItems, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikCheckboxGroup, { label: t('params.roaster.tradingCountries'), name: "trading_countries", items: tradeCountriesItems('trading', formik.values.trading_countries), onChange: handleChangeTradingCountries, formik: formik })),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(FormikCheckboxGroup, { label: t('params.roaster.wantTradeCountries'), name: "want_trade_countries", items: tradeCountriesItems('want', formik.values.want_trade_countries), onChange: handleChangeWantTradeCountries, formik: formik })),
                React.createElement(Grid, { item: true, xs: 2 }),
                React.createElement(Grid, { item: true, xs: 8 },
                    React.createElement(PageSubmitButton, { disabled: !formik.isValid || loading }, t('buttons.update'))),
                React.createElement(Grid, { item: true, xs: 2 })))));
};
export default RoasterEditForm;
var templateObject_1;
